import { MerchantsCardGrid } from "./-components/merchants-card-grid";
import { getAdminMerchantsQueryOptions } from "@/lib/admin-merchants-query";
import { impersonationSession } from "@/lib/impersonation-session";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/_admin-layout/admin")({
  component: MerchantsCardGrid,
  beforeLoad: ({ search, preload }) => {
    if ((search as { applicationId?: string }).applicationId) {
      throw redirect({ to: "/admin", search: {} });
    }
    if (!preload) impersonationSession.clear();
  },
  loader: ({ context }) =>
    context.queryClient.fetchQuery(
      getAdminMerchantsQueryOptions({ accessToken: context.accessToken }),
    ),
});
